const datal =[
  {
    id: 1,
    titulo: 'Conheça nossos serviços',
    subtitulo: 'Soluções personalizadas para você',
    hashtag: '#Serviços,#Soluções',
    preco: '0',
    legenda: '🌐 Oferecemos uma variedade de serviços personalizados para atender às suas necessidades. Conte conosco para soluções eficientes e inovadoras. 🚀',
    dica1: 'Explore',
    dica2: 'Personalize',
    dica3: 'Desfrute',
  },
  {
    "id": "2",
    "titulo": "Transforme Ideias em Realidade",
    "subtitulo": "Do conceito à execução, faça acontecer!",
    "hashtag": "#Empreendedorismo,#Inovação",
    "preco": "0",
    "legenda": "💡 Transforme suas ideias em ações concretas. No mundo dos negócios, a execução é tão importante quanto a inovação. Vamos construir juntos!",
    "dica1": "Criar",
    "dica2": "Implementar",
    "dica3": "Evoluir"
  },
  {
    "id": "3",
    "titulo": "A Arte de Empreender",
    "subtitulo": "Negócios são como obras de arte, cada um único",
    "hashtag": "#ArteEmpreendedora,#Criatividade",
    "preco": "0",
    "legenda": "🎨 Assim como uma obra de arte, seu negócio é uma expressão única de sua visão e paixão. Deixe sua criatividade fluir e crie algo extraordinário!",
    "dica1": "Inspirar",
    "dica2": "Criar",
    "dica3": "Inovar"
  }
  ,
  {
    "id": "4",
    "titulo": "Negócios Sustentáveis",
    "subtitulo": "Construa um futuro próspero e consciente",
    "hashtag": "#Sustentabilidade,#Empreendedorismo",
    "preco": "0",
    "legenda": "🌱 Faça parte da revolução dos negócios sustentáveis. Construa um futuro próspero enquanto cuida do nosso planeta. Juntos, somos mais fortes!",
    "dica1": "Sustentar",
    "dica2": "Cuidar",
    "dica3": "Prosperar"
  }
  ,
  {
    "id": "5",
    "titulo": "Desafios de empreender",
    "subtitulo": "Supere obstáculos e fortaleça sua jornada",
    "hashtag": "#DesafiosEmpreendedorismo,#Persistência",
    "preco": "0",
    "legenda": "🔥 A jornada empreendedora é desafiadora, mas cada desafio é uma oportunidade de crescimento. A persistência é a chave para superar qualquer obstáculo!",
    "dica1": "Persistir",
    "dica2": "Aprender",
    "dica3": "Vencer"
  }
  ,
  {
    "id": "6",
    "titulo": "Negócios Digitais",
    "subtitulo": "Explore o mundo das oportunidades online",
    "hashtag": "#NegóciosDigitais,#Inovação",
    "preco": "0",
    "legenda": "🌐 No mundo digital, as possibilidades são infinitas. Transforme sua visão em realidade e alcance uma audiência global. A revolução começa online!",
    "dica1": "Explorar",
    "dica2": "Digitalizar",
    "dica3": "Conectar"
  }
];
  
  

  export default datal;
  {
    /*


    olá chatgpt, estou lhe usando como ima integração em meu saas de gerar posts para o instagram, responda somente com um array de objetos sem introdução a sua resposta elabore 12 objetos sobre um nutricionista e com a seguinte estrutura de objetos: {
        id:1,
        titulo:'exemplo',
        subtitulo:'exemplo',
        hashtag:'#instalove,#instagood',
        preco:'55', 
        legenda:'exemplo',
        dica1:'dormir',
        dica2:'estudar',
        dica3:'descansar',
    } 
    observações:
    cada dica deve ter no máximo 11 caracteres,
    cada subtitulo deve ter 50 caracteres no minimo,
    seja criativo no titulo para engajar os seguidores
    a legenda deve ser uma breve explicação sobre o titulo de post e deve agregar informação ao leitor

    */
  }